// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomNumberInput_wrapper__IB3wn","label":"CustomNumberInput_label__UPZmK","errorMessage":"CustomNumberInput_errorMessage__6d3P0"};